var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchoolMinnha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 61,
    viewBox: "0 0 109 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6831_9562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2651 6.14146V0H6.4248V6.14146H21.2651Z",
    fill: "#124486"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2236 0.012207H74.7381V6.15201H66.2236V0.012207Z",
    fill: "#124486"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7378 27.7402V10.7335H66.2145V27.7402L57.1042 27.7257V10.7202H33.5998V19.133H48.5822V27.7257H25.7527V10.7202H0V36.1476H74.7214L74.7378 27.7402ZM17.2302 27.7257H8.52331V19.133H17.2302V27.7257Z",
    fill: "#124486"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2461 10.7202V27.727H91.7695V19.133H100.475V27.7257H91.7695V36.1385H109V10.7202H83.2461Z",
    fill: "url(#paint0_linear_6831_9562)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9414 47.3262V47.3676L11.9686 47.3262H11.9414Z",
    fill: "#124486"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9414 53.3835V60.9997H15.3791V48.4126L11.9414 53.3835Z",
    fill: "#124486"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.07272 47.3262H5.05469L5.07272 47.3515V47.3262Z",
    fill: "#124486"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.63574 60.9999H5.0734V53.3692L1.63574 48.3984V60.9999Z",
    fill: "#124486"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5127 52.3296L10.5917 55.3382L11.942 53.3835V47.3662L8.5127 52.3296Z",
    fill: "#124486"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3778 47.3262H11.9686L11.9414 47.3676V53.3841L15.3791 48.4132L15.3778 47.3262Z",
    fill: "#124486"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.07227 47.3516L5.07266 53.3689L6.43389 55.3381L8.51246 52.3295L5.07227 47.3516Z",
    fill: "#124486"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.05373 47.3262H1.63574V48.3984L5.0734 53.3692V47.3515L5.05373 47.3262Z",
    fill: "#124486"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.43359 55.3382L8.51254 58.3469L10.5916 55.3382L8.51259 52.3296L6.43359 55.3382Z",
    fill: "#124486"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0723 47.3262H25.5071V60.9974H22.0723V47.3262Z",
    fill: "#124486"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5066 47.3262V55.6368L35.6359 47.3262H32.2012V60.9978H35.6359V52.6889L42.5066 60.9978H45.9443V47.3262H42.5066Z",
    fill: "#124486"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9422 47.3262V55.6368L56.0715 47.3262H52.6338V60.9978H56.0715V52.6889L62.9422 60.9978H66.3769V47.3262H62.9422Z",
    fill: "#124486"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5456 47.3262V52.468H77.6749V47.3262H74.2402V60.9978H77.6749V55.8577H84.5456V60.9978H87.9803V47.3262H84.5456Z",
    fill: "#124486"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.615 60.9438H107.246L102.369 47.3823H98.3601L93.5029 60.9438H97.1343L97.956 58.6903H102.788L103.615 60.9438ZM99.1931 55.2981L100.367 52.0809L101.546 55.2981H99.1931Z",
    fill: "#124486"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7217 27.7261H83.2308V36.1388H74.7217V27.7261Z",
    fill: "#F5D45C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6831_9562",
    x1: -21.1463,
    y1: 30.9882,
    x2: 159.306,
    y2: 27.2886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CACA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#124486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153F5F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6831_9562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 109,
    height: 61,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolMinnha);
export default __webpack_public_path__ + "static/media/schoolMinnha.196bbb28aac9bde024b55da9016b717d.svg";
export { ForwardRef as ReactComponent };